import React, { useCallback, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { useQuery } from 'hooks/apollo';
import { CASCO_CATEGORIES } from 'features/insuranceConventions/edit/queries';
import { Box, Grid, Icon } from '@mui/material';
import { Autocomplete, FakeText, Typography } from '@totalsoft/rocket-ui';
import { useTranslation } from 'react-i18next';
import InsuranceConventionUsageGridsContainer from './InsuranceConventionUsageGridsContainer';

const InsuranceConventionUsageTableContainer = ({ productId }) => {
  const { t } = useTranslation();

  const [categoryId, setCategoryId] = useState(null);
  const [adding, setAdding] = useState(false);

  const isNewConvention = useMemo(() => !productId, [productId]);

  const { data: cascoCategoriesData, loading } = useQuery(CASCO_CATEGORIES);

  const cascoCategories = useMemo(() => cascoCategoriesData?.cascoCategories || [], [cascoCategoriesData]);

  const handleCategoryChange = useCallback(categoryId => {
    setCategoryId(categoryId);
    setAdding(false);
  }, []);

  return (
    <Grid container flexDirection='column' spacing={2} p={2}>
      {!isNewConvention && loading && (
        <Grid item>
          <FakeText lines={5} />
        </Grid>
      )}
      {!isNewConvention && !loading && (
        <>
          <Grid item xs={12} md={6}>
            <Box px={1}>
              <Autocomplete
                label={t('InsuranceConventions.Details.UsageTable.Category')}
                simpleValue
                value={categoryId}
                onChange={handleCategoryChange}
                options={cascoCategories}
              />
            </Box>
          </Grid>
          <Grid item>
            <InsuranceConventionUsageGridsContainer productId={productId} categoryId={categoryId} adding={adding} setAdding={setAdding} />
          </Grid>
        </>
      )}
      {isNewConvention && (
        <Grid item container gap={1} alignItems='center' justifyContent='center'>
          <Icon fontSize='small' color='primary'>
            error
          </Icon>
          <Typography color='textPrimary'>{t('InsuranceConventions.Details.Warning')}</Typography>
        </Grid>
      )}
    </Grid>
  );
};

InsuranceConventionUsageTableContainer.propTypes = {
  productId: PropTypes.number
};

export default InsuranceConventionUsageTableContainer;
